/************客服相关****************/
import { request } from "@/utils/request.js";
//获取法务列表
export function getadminServiceList(data) {
  return request({
    url: "/admin/order/getlayer_list",
    method: "post",
    data,
  });
}
// 客服列表
export function getUserList(data) {
  return request({
    url: "/admin/user/service/lists",
    method: "post",
    showLoading: false,
    data,
  });
}
// 客服 新增 编辑
export function addUserService(data) {
  return request({
    url: "/admin/user/service/renew",
    method: "post",
    showLoading: false,
    data,
  });
}

// 客服详情
export function userServiceDetail(data) {
  return request({
    url: "/admin/user/service/details",
    method: "post",
    showLoading: false,
    data,
  });
}

// 获取客服可接待数量
export function getChatGroup(data) {
  return request({
    url: "/admin/user/service/get_chat_group",
    method: "post",
    data,
  });
}

// 关联姓名（编辑客服的时候列表选择）
export function servicePerson(data) {
  return request({
    url: "/admin/user/service/servicePerson",
    method: "post",
    data,
  });
}

// 快捷咨询 - 列表
export function getConsultList(data) {
  return request({
    url: "/admin/operate/consultation/lists",
    method: "post",
    data,
  });
}

// 接待记录列表
export function getReceptionRecordList(data) {
  return request({
    url: "/admin/user/record/lists",
    method: "post",
    showLoading: false,
    data,
  });
}
